import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import { defaultURL, proteksiMeta } from "../../data/DataMetatags";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { ProteksiBreadcrumb } from "../../data/DataBreadcrumb";
import HeadingComponent from "../../components/UserInterface/HeadingComponent";
import ProtectionList from "../../components/Protection/ProtectionList";
import { useEffect } from "react";
import { GACustomEvent } from "src/utils/analytics";

const Protection = ({ pageTitle, descriptionSEO, asPath }) => {
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle
      }
    }
  ];

  useEffect(() => {
    GACustomEvent("protection_list_page", "view");
  }, []);

  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={ProteksiBreadcrumb}></BreadcrumbComponent>
      <HeadingComponent
        headingText="Proteksi"
        fontSize="32px"
        fontSizeMobile="20px"
        fontWeight="bold"
        fontFamily="Roboto-bold"
      ></HeadingComponent>
      <ProtectionList />
    </Layout>
  );
};

Protection.getInitialProps = async ({ asPath }) => {
  const pageTitle = proteksiMeta.title;
  const descriptionSEO = proteksiMeta.description;
  return { pageTitle, descriptionSEO, asPath };
};
export default Protection;
